// Haptic feedback helpers for GemPulse PWA.
// Android/Chrome: vibrates via navigator.vibrate (guarded — not all browsers support it).
// iOS Safari: navigator.vibrate is undefined, so every call also bounces the
// triggering element with a CSS scale transform for a "visual haptic" equivalent.
//
// Usage:  import * as Haptics from './haptics';
//         <button onClick={e => { Haptics.medium(e.currentTarget); doAction(); }} />
//
// The `el` parameter is optional — vibration still fires without it, but the
// visual bounce won't play (acceptable on desktop where it's subtle anyway).

const CLS = 'gp-haptic-tap';

function ensureStyle() {
  if (document.getElementById('__gp_haptic_style')) return;
  const s = document.createElement('style');
  s.id = '__gp_haptic_style';
  // 60 ms compress → auto-remove at 120 ms via JS; transition restores naturally.
  s.textContent =
    `.${CLS}{transform:scale(0.96)!important;` +
    `transition:transform 60ms ease-out!important}`;
  document.head.appendChild(s);
}

function bounce(el) {
  if (!el) return;
  ensureStyle();
  el.classList.add(CLS);
  setTimeout(() => el.classList.remove(CLS), 120);
}

function vibe(pattern) {
  if (navigator.vibrate) navigator.vibrate(pattern);
}

// light — 30 ms pulse; for low-stakes actions (remove, dismiss, filter toggle)
export const light = (el) => { vibe(30); bounce(el); };

// medium — 50 ms pulse; for standard confirmations (add ticker, save alert)
export const medium = (el) => { vibe(50); bounce(el); };

// heavy — 70 ms pulse; for major CTA actions (Build / Optimize Portfolio)
export const heavy = (el) => { vibe(70); bounce(el); };

// success — triple pulse; for positive completion (alert saved, build complete)
export const success = (el) => { vibe([30, 30, 50]); bounce(el); };
